<template>
	<div class="list-wrapper" v-if="list && list.length">
		<div v-for="(item, index) in list" :key="item[rowKey]">
			<div class="list-item">
				<div v-src="item[imgKey]" :style="imgStyle" class="img">
					<div v-if="watching" class="flex-center">
						<img src="@/assets/imgs/watching.png" />
					</div>
				</div>
				<div class="right">
					<div class="title" v-html="$root.replaceWithSub(item[nameKey])"></div>
					<div class="speaker" v-if="item.speaker">
						{{ item.speakerKey || '讲师' }}: {{item.speaker.split(/[;；]/g).join('，')}}
					</div>
					<div class="bottom">
						<div class="date" v-if="item.time">{{ item.time }}</div>
						<slot name="button" :item="item">
							<div class="default-button" @click="$emit('click-button', item)">
								<img src="@/assets/imgs/查看详情.png" />
								查看详情
							</div>
						</slot>
					</div>
				</div>
			</div>
			<div class="line" v-if="list.length - 1 !== index"></div>
		</div>
	</div>
	<van-empty description="敬请期待" v-else></van-empty>
</template>
<script>
	export default {
		props: {
			list: {
				type: Array
			},
			imgStyle: {
				type: Object
			},
			nameKey: {
				type: String,
				default: 'title'
			},
			imgKey: {
				type: String,
				default: 'img'
			},
			rowKey: {
				type: String,
				default: 'id'
			},
			watching: {
				type: Boolean,
				default: false
			}
		}
	}
</script>
<style scoped lang="less">
	.list-item {
		display: flex;
		justify-content: space-between;
		align-items: center;
		clear: both;
		> .img {
			width: 6rem;
			height: 4.5rem;
			margin-right: 0.8rem;
			background: transparent no-repeat center/contain;
			.flex-center {
				background: rgba(0, 0, 0, 0.5);
				> img {
					width: 1.7rem;
					object-fit: contain;
				}
			}
		}
		.cover {
			opacity: 0.5;
		}

		.right {
			flex: 1;
			> div:not(:first-child) {
				margin-top: 0.4rem;
			}
			.title {
				font-weight: 500;
			}
			.date {
				opacity: 0.5;
			}
			.bottom {
				display: flex;
				justify-content: space-between;
				align-items: center;
			}
			.speaker {
				> a:not(:first-child) {
					margin-left: 5px;
				}
			}
		}
	}
	.line {
		float: right;
		width: calc(100% - 6.8rem);
		margin: 0.6rem 0;
		border-bottom: 1px solid #d8d8d8;
	}

	.online-course-list {
		.list-item .flex-center {
			background: transparent !important;
			display: none !important;
		}
	}
</style>
